import { takeLatest, put, call } from 'redux-saga/effects';

import { findTabelaTributaria } from '../service';
import {
  FIND_TABELA_TRIBUTARIA,
  FIND_TABELA_TRIBUTARIA_PENDING,
  FIND_TABELA_TRIBUTARIA_SUCCESS,
  FIND_TABELA_TRIBUTARIA_FAILURE
} from '../actionTypes';

function* sagaFindTabelaTributaria(action) {
  yield put({ type: FIND_TABELA_TRIBUTARIA_PENDING, id: action.id })

  try {

    const registro = yield call(findTabelaTributaria, action.id);

    // Garantir valores padrão para campos IBS/CBS que podem vir null do backend
    if (registro.ibsCbs) {
      registro.ibsCbs = {
        ...registro.ibsCbs,
        aliquotaCbs: registro.ibsCbs.aliquotaCbs ?? 0,
        aliquotaDiferimentoCbs: registro.ibsCbs.aliquotaDiferimentoCbs ?? 0,
        aliquotaReducaoCbs: registro.ibsCbs.aliquotaReducaoCbs ?? 0,
        aliquotaIbsEstadual: registro.ibsCbs.aliquotaIbsEstadual ?? 0,
        aliquotaDiferimentoIbsEstadual: registro.ibsCbs.aliquotaDiferimentoIbsEstadual ?? 0,
        aliquotaReducaoIbsEstadual: registro.ibsCbs.aliquotaReducaoIbsEstadual ?? 0,
        aliquotaIbsMunicipal: registro.ibsCbs.aliquotaIbsMunicipal ?? 0,
        aliquotaDiferimentoIbsMunicipal: registro.ibsCbs.aliquotaDiferimentoIbsMunicipal ?? 0,
        aliquotaReducaoIbsMunicipal: registro.ibsCbs.aliquotaReducaoIbsMunicipal ?? 0,
      };
    }

    yield put({ type: FIND_TABELA_TRIBUTARIA_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_TABELA_TRIBUTARIA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindTabelaTributaria() {
  yield takeLatest(FIND_TABELA_TRIBUTARIA, sagaFindTabelaTributaria)
}
